var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['audio-player', {'is-playing': _vm.playing}]},[_c('a',{class:_vm.className,attrs:{"href":"#","label":_vm.useLabel ? _vm.useLabel : _vm.label},on:{"click":function($event){$event.preventDefault();return _vm.togglePlayButton.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.useLabel ? _vm.useLabel : _vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }